function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.954
    },
    fill: "#000000",
    d: "M 53.5,-0.5 C 54.8333,-0.5 56.1667,-0.5 57.5,-0.5C 59.475,0.646381 60.975,2.31305 62,4.5C 62.6667,34.1667 62.6667,63.8333 62,93.5C 61.4015,96.2542 59.9015,98.2542 57.5,99.5C 56.1667,99.5 54.8333,99.5 53.5,99.5C 42.9263,90.4304 32.7596,80.7638 23,70.5C 21.8686,63.6012 21.3686,56.6012 21.5,49.5C 21.3686,42.3988 21.8686,35.3988 23,28.5C 32.7596,18.2362 42.9263,8.56957 53.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.774
    },
    fill: "#000000",
    d: "M 77.5,20.5 C 86.6108,22.7704 92.7775,28.4371 96,37.5C 100.847,52.5962 97.3467,65.4295 85.5,76C 83.6096,77.1123 81.6096,77.9456 79.5,78.5C 78.09,78.1322 77.09,77.2989 76.5,76C 80.6667,72.5 84.5,68.6667 88,64.5C 96.3383,47.85 92.6716,34.5167 77,24.5C 76.4209,23.0715 76.5876,21.7382 77.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.897
    },
    fill: "#000000",
    d: "M 6.5,28.5 C 10.5,28.5 14.5,28.5 18.5,28.5C 17.1667,42.5 17.1667,56.5 18.5,70.5C 13.4012,70.8254 8.40118,70.3254 3.5,69C 2.10679,67.8289 1.27346,66.3289 1,64.5C 0.0691937,53.4272 0.402527,42.4272 2,31.5C 3.40875,30.2189 4.90875,29.2189 6.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.768
    },
    fill: "#000000",
    d: "M 67.5,34.5 C 76.7619,35.095 81.7619,40.095 82.5,49.5C 82.2128,57.2801 78.3795,62.2801 71,64.5C 68.0585,64.5633 67.0585,63.23 68,60.5C 76.1386,57.2229 78.4719,51.5562 75,43.5C 73.0188,41.3425 70.6855,39.6759 68,38.5C 67.51,37.2068 67.3433,35.8734 67.5,34.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.e34530d74910195cac1a76d40e119d85.svg";
export { ForwardRef as ReactComponent };